import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ImageIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M20.0231 2.875C20.2147 2.87447 20.4045 2.91196 20.5815 2.98529C20.7586 3.05861 20.9193 3.16633 21.0544 3.30219L26.6875 8.93531C26.8233 9.07043 26.931 9.23114 27.0044 9.40815C27.0777 9.58517 27.1152 9.77496 27.1147 9.96656V27.6666C27.1147 28.4709 26.4538 29.125 25.6416 29.125H6.34812C5.53562 29.125 4.875 28.4709 4.875 27.6666V4.33344C4.875 3.52906 5.53594 2.875 6.34812 2.875H20.0231ZM20.0231 2H6.34812C5.05125 2 4 3.04469 4 4.33344V27.6666C4 28.9553 5.05125 30 6.34812 30H25.6416C26.9384 30 27.9897 28.9553 27.9897 27.6666V9.96656C27.9896 9.34771 27.7438 8.75421 27.3062 8.31656L21.6731 2.68344C21.2355 2.24592 20.642 2.0001 20.0231 2Z"
        fill="currentColor"
      />
      <path
        d="M20 2V7.33344C20.0001 8.04063 20.281 8.71883 20.7811 9.21889C21.2812 9.71895 21.9594 9.99992 22.6666 10H28L20 2Z"
        fill="currentColor"
      />
      <path
        d="M12.796 17.5467L9 21H22L18.048 14L14.096 18.76L12.796 17.5467Z"
        fill="currentColor"
      />
      <circle cx="13" cy="15" r="1" fill="currentColor" />
    </SvgIcon>
  );
};

export default memo(ImageIcon);
